import styled from "styled-components";

export const AnchorStyled = styled.div`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
